module.exports = __webpack_public_path__ + "static/icon-blue-orange.7b1d83d8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-blue-orange.png
// module id = 281
// module chunks = 2